import { Button } from "@/components/ui/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog.tsx";
import { User } from "@/lib/api/user";
import { getAge } from "@/lib/utils";

interface MoreInfoProps {
  data: User;
}

export function MoreInfo({ data }: MoreInfoProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="mx-auto flex">
          View Details
        </Button>
      </DialogTrigger>
      <DialogContent className="flex max-h-[90vh] flex-col overflow-hidden p-0 sm:max-w-[425px]">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle>More Info</DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto">
          <div className="px-6 pb-6">
            <div className="text-sm font-semibold uppercase tracking-wide text-indigo-500">
              Teen Profile
            </div>
            <div className="mt-4 space-y-2">
              <p className="text-lg font-semibold leading-tight text-black">
                First Name:{" "}
                <span className="font-medium text-gray-700">
                  {data?.first_name || "N/A"}
                </span>
              </p>
              <p className="text-lg font-semibold leading-tight text-black">
                Last Name:{" "}
                <span className="font-medium text-gray-700">
                  {data?.last_name || "N/A"}
                </span>
              </p>
              <p className="text-gray-700">
                Preferred Name:{" "}
                <span className="font-medium">{data?.name || "N/A"}</span>
              </p>
              <p className="text-gray-700">
                Age:{" "}
                <span className="font-medium">
                  {data?.birthday
                    ? getAge(new Date(data?.birthday).toISOString()) || "N/A"
                    : "N/A"}{" "}
                  years old
                </span>
              </p>
              <p className="text-gray-700">
                Sex:{" "}
                <span className="font-medium">
                  {data?.profile?.sex || "N/A"}{" "}
                </span>
              </p>
              <p className="text-gray-700">
                Pronouns:{" "}
                <span className="font-medium">{data?.pronouns || "N/A"}</span>
              </p>
              <p className="text-gray-700">
                Race:{" "}
                <span className="font-medium">
                  {data?.profile?.race || "N/A"}
                </span>
              </p>
            </div>
            <div className="mt-6">
              <div className="text-sm font-semibold text-indigo-500">
                Interests:{" "}
                <p className="text-gray-700">
                  <span className="font-medium">
                    {data?.profile?.interests?.join(", ") || "N/A"}
                  </span>
                </p>
              </div>
            </div>
            {/* <div className="mt-6">
              <div className="text-sm font-semibold text-indigo-500">
                Struggles With:
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  <span className="font-medium">
                    {data?.profile?.struggles?.join(", ") || "N/A"}
                  </span>
                </p>
              </div>
            </div> */}
            {/* <div className="mt-6">
              <div className="text-sm font-semibold text-indigo-500">
                Healthcheck
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  CSSRS-1:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.cssrs1 || "N/A"}
                  </span>
                </p>
                <p className="text-gray-700">
                  CSSRS-2:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.cssrs2 || "N/A"}
                  </span>
                </p>
                <p className="text-gray-700">
                  CSSRS-3:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.cssrs3 || "N/A"}
                  </span>
                </p>
                <p className="text-gray-700">
                  CSSRS-4:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.cssrs4 || "N/A"}
                  </span>
                </p>
                <p className="text-gray-700">
                  CSSRS-5:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.cssrs5 || "N/A"}
                  </span>
                </p>
                <p className="text-gray-700">
                  Fearful of Losing Access:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.safety || "N/A"}
                  </span>
                </p>
              </div>
            </div>
            <div className="mt-6">
              <div className="text-sm font-semibold text-indigo-500">
                Re-Admission
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  Mental Health Resource:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.readmission1 || "N/A"}
                  </span>
                </p>
                <p className="text-gray-700">
                  Last Released:{" "}
                  <span className="font-medium">
                    {data?.teen?.healthcheck?.readmission2 || "N/A"}
                  </span>
                </p>
              </div>
            </div> */}
            <div className="mt-6">
              <div className="text-sm font-semibold text-indigo-500">
                Mentor Preferences
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  Help With:{" "}
                  <span className="font-medium">
                    {data?.profile?.metadata?.mentorPreferences?.helpWith?.join(
                      ", ",
                    ) || "N/A"}{" "}
                  </span>
                </p>
                {/* <p className="text-gray-700">
                  Method of Contact:{" "}
                  <span className="font-medium">
                    {data?.teen?.mentorPreferences?.methodOfContact?.join(
                      ", ",
                    ) || "N/A"}{" "}
                  </span>
                </p> */}
              </div>
            </div>
            {/* <div className="mt-6">
              <div className="text-sm font-semibold uppercase tracking-wide text-indigo-500">
                Personal Information
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  State & Zip:{" "}
                  <span className="font-medium">
                    {data?.teen?.state}, {data?.teen?.zipcode}
                  </span>
                </p>
                <p className="text-gray-700">
                  SMS Acceptance:{" "}
                  <span className="font-medium">
                    {data?.teen?.smsOptIn ? "Yes" : "No"}
                  </span>
                </p>
              </div>
            </div> */}

            <div className="mt-6">
              <div className="text-sm font-semibold uppercase tracking-wide text-indigo-500">
                Parent/Emergency Contact
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  Parent Allowed:{" "}
                  <span className="font-medium">
                    {data?.profile?.metadata?.parentConsent === "Yes"
                      ? "Yes"
                      : "No"}
                  </span>
                </p>
                {data?.profile?.metadata?.parentConsent === "Yes" ? (
                  <>
                    {/* <p className="text-gray-700">
                      Parent Name:{" "}
                      <span className="font-medium">
                        {data?.profile?.parentName || "N/A"}
                      </span>
                    </p> */}
                    <p className="text-gray-700">
                      Parent Contact:{" "}
                      <span className="font-medium">
                        {data?.emergency_phone || "N/A"}
                      </span>
                    </p>
                  </>
                ) : (
                  <>
                    <p className="text-gray-700">
                      Reason for No Parent:{" "}
                      <span className="font-medium">
                        {data?.profile?.metadata?.parentOptOutReason || "N/A"}
                      </span>
                    </p>
                    <p className="text-gray-700">
                      Emergency Contact Phone:{" "}
                      <span className="font-medium">
                        {data?.emergency_phone || "N/A"}
                      </span>
                    </p>
                  </>
                )}
              </div>
            </div>

            <div className="mt-6">
              <div className="text-sm font-semibold uppercase tracking-wide text-indigo-500">
                Additional Information
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  Insurance Provider:{" "}
                  <span className="font-medium">
                    {data?.profile?.metadata?.insuranceProvider || "N/A"}
                  </span>
                </p>
              </div>
            </div>

            <div className="mt-6">
              <div className="text-sm font-semibold text-indigo-500">
                Mentor Match
              </div>
              <div className="mt-2 space-y-1">
                <p className="text-gray-700">
                  Name:{" "}
                  <span className="font-medium">
                    {data?.metadata?.onboarding?.mentor?.name || "N/A"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
